import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Sun } from "lucide-react";
import { MantraAudioIcon } from "@/components/audio/MantraAudioIcon";

export function DailyGuidance({ guidance, date }) {
  if (!guidance) return null;
  return (
    <Card className="bg-gradient-to-br from-white to-primary/5 shadow-card md:col-span-2" data-testid="journey-daily-guidance">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Sun className="w-4 h-4 text-amber-500" />
          Today&apos;s guidance
          {date && <span className="text-xs font-normal text-muted-foreground ml-2">{date}</span>}
        </CardTitle>
      </CardHeader>
      <CardContent className="text-sm grid sm:grid-cols-2 gap-4">
        <div>
          <p className="text-xs text-muted-foreground uppercase tracking-wide">Sādhana</p>
          <p>{guidance.sadhana}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground uppercase tracking-wide">Mantra</p>
          <div className="inline-flex items-center gap-2">
            <p>{guidance.mantra}</p>
            <MantraAudioIcon mantra={guidance.mantra} />
          </div>
        </div>
        <div>
          <p className="text-xs text-muted-foreground uppercase tracking-wide">Tattva focus</p>
          <p>{guidance.tattva_focus}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground uppercase tracking-wide">Dharma principle</p>
          <p className="capitalize">{guidance.dharma_principle}</p>
        </div>
        <div className="sm:col-span-2">
          <p className="text-xs text-muted-foreground uppercase tracking-wide">Story</p>
          <p>{guidance.story_title || guidance.story_id}</p>
        </div>
      </CardContent>
    </Card>
  );
}
